'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
require('../../node_modules/framer-motion/dist/es/context/MotionConfigContext.js');
require('../../node_modules/framer-motion/dist/es/context/PresenceContext.js');
require('../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js');
require('../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.js');
require('../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js');
require('../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/utils/batcher.js');
require('../../node_modules/framer-motion/dist/es/context/SharedLayoutContext.js');
require('../../node_modules/framer-motion/dist/es/motion/index.js');
require('../../node_modules/framer-motion/dist/es/events/use-dom-event.js');
require('../../node_modules/framer-motion/dist/es/motion/features/drag.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-pan-gesture.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-gestures.js');
require('../../node_modules/framer-motion/dist/es/motion/features/gestures.js');
require('../../node_modules/framer-motion/dist/es/motion/features/exit.js');
require('../../node_modules/framer-motion/dist/es/value/index.js');
require('../../node_modules/framer-motion/dist/es/render/utils/animation.js');
require('../../node_modules/framer-motion/dist/es/animation/animation-controls.js');
require('../../node_modules/framer-motion/dist/es/motion/features/animation.js');
require('../../node_modules/framer-motion/dist/es/motion/features/layout/Animate.js');
require('../../node_modules/framer-motion/dist/es/render/dom/projection/scale-correction.js');
require('../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.js');
require('../../node_modules/framer-motion/dist/es/render/index.js');
require('../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.js');
const motion = require('../../node_modules/framer-motion/dist/es/render/dom/motion.js');
require('../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.js');
require('../../node_modules/framer-motion/dist/es/animation/animate.js');
require('../../node_modules/framer-motion/dist/es/animation/use-animation.js');
const modal = require('../Modal/modal.js');

var _excluded = ["BackdropComponent", "backdropProps", "closeButtonProps", "ContentComponent", "contentProps", "dataAttr", "portalProps"],
  _excluded2 = ["dataAttr"],
  _excluded3 = ["dataAttr"],
  _excluded4 = ["dataAttr"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var COMPONENT_KEY = 'modal-with-animation';
var CONTENT_VARIANT_OVERRIDES = {
  hide: {
    y: 24
  },
  show: {
    y: 0,
    transition: {
      delay: 0.2
    }
  }
};
var DEFAULT_DATA_ATTR = {
  'data-testid': COMPONENT_KEY
};
var DEFAULT_DATA_ATTR_BACKDROP = {
  'data-testid': "".concat(COMPONENT_KEY, "__backdrop")
};
var DEFAULT_DATA_ATTR_CLOSE_BUTTON = {
  'data-testid': "".concat(COMPONENT_KEY, "__close-button")
};
var DEFAULT_DATA_ATTR_CONTENT = {
  'data-testid': "".concat(COMPONENT_KEY, "__content-container")
};
var DEFAULT_VARIANTS = {
  hide: {
    opacity: 0
  },
  show: {
    opacity: 1
  }
};
var getAnimationProps = function getAnimationProps(_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? motion.motion.div : _ref$as,
    isStyledComponent = _ref.isStyledComponent,
    key = _ref.key,
    _ref$variantOverrides = _ref.variantOverrides,
    variantOverrides = _ref$variantOverrides === void 0 ? {} : _ref$variantOverrides;
  var variants = _objectSpread({}, DEFAULT_VARIANTS);

  /** Currently only supporting `hide` and `show` properties */
  if ('hide' in variantOverrides) {
    variants.hide = _objectSpread(_objectSpread({}, variants.hide), variantOverrides.hide);
  }
  if ('show' in variantOverrides) {
    variants.show = _objectSpread(_objectSpread({}, variants.show), variantOverrides.show);
  }
  var animationProps = {
    key: key,
    initial: 'hide',
    animate: 'show',
    exit: 'hide',
    variants: variants
  };

  /**
   * The Modal subcomponents (Backdrop, ModalContent) can be replaced, and it is feasible that they may be
   * replaced with styled components, or the same components but wrapped and customized.
   * - e.g., const CustomModalContent = styled(ModalContent)``;
   * In such cases, `forwardedAs` is necessary to ensure it will be passed along to the wrapped component.
   * Reference: https://styled-components.com/docs/api#forwardedas-prop
   */
  if (isStyledComponent) {
    animationProps.forwardedAs = as;
  } else {
    animationProps.as = as;
  }
  return animationProps;
};
var ModalWithAnimation = function ModalWithAnimation(_ref2) {
  var BackdropComponent = _ref2.BackdropComponent,
    _ref2$backdropProps = _ref2.backdropProps,
    backdropProps = _ref2$backdropProps === void 0 ? {} : _ref2$backdropProps,
    _ref2$closeButtonProp = _ref2.closeButtonProps,
    closeButtonProps = _ref2$closeButtonProp === void 0 ? {} : _ref2$closeButtonProp,
    ContentComponent = _ref2.ContentComponent,
    _ref2$contentProps = _ref2.contentProps,
    contentProps = _ref2$contentProps === void 0 ? {} : _ref2$contentProps,
    dataAttr = _ref2.dataAttr,
    portalProps = _ref2.portalProps,
    props = _objectWithoutProperties(_ref2, _excluded);
  var animatedBackdropProps = getAnimationProps({
    isStyledComponent: styled.isStyledComponent(BackdropComponent),
    key: "".concat(COMPONENT_KEY, "__backdrop")
  });
  var animatedContentProps = getAnimationProps({
    isStyledComponent: styled.isStyledComponent(ContentComponent),
    key: "".concat(COMPONENT_KEY, "__content"),
    variantOverrides: CONTENT_VARIANT_OVERRIDES
  });
  var backdropDataAttr = backdropProps.dataAttr,
    restBackdropProps = _objectWithoutProperties(backdropProps, _excluded2);
  var combinedBackdropProps = _objectSpread(_objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_BACKDROP), backdropDataAttr)
  }, animatedBackdropProps), restBackdropProps);
  var closeButtonDataAttr = closeButtonProps.dataAttr,
    restCloseButtonProps = _objectWithoutProperties(closeButtonProps, _excluded3);
  var combinedCloseButtonProps = _objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_CLOSE_BUTTON), closeButtonDataAttr)
  }, restCloseButtonProps);
  var contentDataAttr = contentProps.dataAttr,
    restContentProps = _objectWithoutProperties(contentProps, _excluded4);
  var combinedContentProps = _objectSpread(_objectSpread({
    dataAttr: _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR_CONTENT), contentDataAttr)
  }, animatedContentProps), restContentProps);
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  var combinedPortalProps = _objectSpread(_objectSpread({}, portalProps), {}, {
    isTransitionable: true
  });
  return /*#__PURE__*/React__default.createElement(modal, _extends({
    BackdropComponent: BackdropComponent,
    backdropProps: combinedBackdropProps,
    closeButtonProps: combinedCloseButtonProps,
    ContentComponent: ContentComponent,
    contentProps: combinedContentProps,
    dataAttr: combinedDataAttr,
    portalProps: combinedPortalProps
  }, props));
};
const ModalWithAnimation$1 = /*#__PURE__*/React__default.memo(ModalWithAnimation);

exports.CONTENT_VARIANT_OVERRIDES = CONTENT_VARIANT_OVERRIDES;
exports.default = ModalWithAnimation$1;
exports.getAnimationProps = getAnimationProps;
